import React from 'react';
import { X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export function TrialModal({ isOpen, onClose, onCreateAccount, onSignIn }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      data-testid="trial-modal-overlay"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="relative w-full max-w-sm rounded-2xl border border-slate-700/60 bg-slate-900 p-8 shadow-2xl shadow-black/40"
        style={{ animation: 'trial-scale-in 200ms cubic-bezier(0.16, 1, 0.3, 1)' }}
        data-testid="trial-modal"
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-7 h-7 rounded-lg flex items-center justify-center text-slate-500 hover:text-slate-300 hover:bg-slate-800 transition-colors"
          data-testid="trial-modal-close"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Content */}
        <div className="text-center">
          <h2
            className="text-xl font-bold text-white mb-1"
            data-testid="trial-modal-heading"
          >
            Start your free trial
          </h2>
          <p className="text-xs font-medium text-indigo-400 mb-5" data-testid="trial-modal-trust">
            No credit card required
          </p>
          <p className="text-sm text-slate-400 leading-relaxed mb-7" data-testid="trial-modal-body">
            Create your account in seconds and start building better compliance training.
          </p>

          <Button
            onClick={onCreateAccount}
            className="w-full h-11 rounded-xl text-sm font-bold bg-indigo-600 hover:bg-indigo-500 text-white shadow-lg shadow-indigo-600/20 transition-all"
            data-testid="trial-modal-create-btn"
          >
            Create account <ArrowRight className="w-4 h-4 ml-1" />
          </Button>

          <p className="mt-4 text-xs text-slate-500" data-testid="trial-modal-signin">
            Already have an account?{' '}
            <button
              onClick={onSignIn}
              className="text-indigo-400 hover:text-indigo-300 font-semibold transition-colors"
              data-testid="trial-modal-signin-btn"
            >
              Sign in
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
